"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HexOfXiiaAbilityHandler = exports.HexOfXiiaActorAbilityFactory = exports.HexOfXiiaAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Curse_1 = require("../../core/effects/core/Curse");
const Darkness_1 = require("../../core/effects/core/Darkness");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class HexOfXiiaAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.HexOfXiia;
        this.__typeName = "HexOfXiia";
    }
}
exports.HexOfXiiaAbilityArgs = HexOfXiiaAbilityArgs;
let HexOfXiiaActorAbilityFactory = class HexOfXiiaActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("HexOfXiia", "AllEnemies", 3);
    }
};
HexOfXiiaActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("HexOfXiia")
], HexOfXiiaActorAbilityFactory);
exports.HexOfXiiaActorAbilityFactory = HexOfXiiaActorAbilityFactory;
let HexOfXiiaAbilityHandler = class HexOfXiiaAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                    .forEach(enemy => {
                    container.applyProjectileAttackWithDamage({
                        sequence,
                        abilityKey: ability.args.__typeName,
                        attackType: "magic",
                        attackerId: ability.invokerId,
                        targetId: enemy,
                        toApply: [
                            AbilityDamage_1.AbilityDamage.Focus("Death", 70)
                        ],
                        projectileType: "BlackSmoke",
                        projectilePath: "line",
                        onHit(sequence) {
                            container.applyDebuff({
                                sequence,
                                attackerId: ability.invokerId,
                                targetId: enemy,
                                duration: Duration_1.Duration.Turns(4),
                                effect: new core_1.LinkedEffectsEffectArgs([
                                    new Curse_1.CurseEffectArgs("Focus", 10),
                                    new Darkness_1.DarknessEffectArgs(),
                                ], true),
                            });
                        }
                    });
                });
            }
        });
    }
};
HexOfXiiaAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.HexOfXiia)
], HexOfXiiaAbilityHandler);
exports.HexOfXiiaAbilityHandler = HexOfXiiaAbilityHandler;
